export default "__VITE_ASSET__92b15f3b__"